namespace AgerLMS.LMS {
    export interface OrderListRequest extends Serenity.ListRequest {
        AllPaidOrders?: boolean;
        FreeOrders?: boolean;
        UnpaidOrders?: boolean;
        OrderConfirmPayment?: boolean;
        DiscountOrders?: boolean;
    }
}
